import m from 'mithril';
import './css/index.scss';
import routes from './routes';
import app from './app';

const start = async () => {
	app.init();

	const root = document.getElementById('root');
	m.route(root, '/', routes);
};

window.addEventListener('DOMContentLoaded', start);
